import { createFileRoute } from "@tanstack/react-router";
import { PlaybooksPage } from "../../../components/playbooks/playbooks-page";
import { playbooksSearchSchema } from "../../../lib/playbooks/list";

/**
 * Every published playbook and the person's own drafts. The search and the filters live in the
 * address (see `playbooksSearchSchema`), so back from an opened playbook lands on the same list.
 */
export const Route = createFileRoute("/_authenticated/_workspace/playbooks/")({
  validateSearch: playbooksSearchSchema,
  component: function PlaybooksRoute() {
    const search = Route.useSearch();
    const navigate = Route.useNavigate();
    return (
      <PlaybooksPage
        search={search}
        onChange={(patch) =>
          // Filtering is not a new page: replace the entry, and skip the page-wide transition.
          void navigate({
            search: (previous) => ({ ...previous, ...patch }),
            replace: true,
            viewTransition: false,
          })
        }
      />
    );
  },
});
